import BellFilled from './BellFilled';
import BellOutlineThick from './BellOutlineThick';
import BellOutlineThin from './BellOutlineThin';

export default function NotifyMeBell({
  variant,
  mode = 'light'
}: {
  mode?: 'light' | 'dark';
  variant: 'thick' | 'thin' | 'filled';
}) {
  switch (variant) {
    case 'filled':
      return (
        <BellFilled
          fill={mode === 'dark' ? '#D19FF4' : '#8907E7'}
          height="14"
          width="12"
        />
      );
    case 'thick':
      return (
        <BellOutlineThick
          stroke={mode === 'dark' ? 'black' : 'white'}
          height="14"
          width="12"
        />
      );
    case 'thin':
      return <BellOutlineThin fill="black" height="20" width="20" />;
  }
}
